import React, { memo, useEffect, useMemo } from "react";
import { useFormik } from "formik";

import { CustomSelect, Error, Label } from "../";
import { badlaOpions } from "../../Static/data";
import { useBadlaType } from "../../Hooks";
import { badlaCreateSchema } from "../../Schema/BadlaSchema";

const SelectBadla = ({
  handleSelectBadla,
  isClearForm,
  setIsClearForm,
  customClass = "col-lg-2",
  badlaType = "",
  settingName = "",
  isRemoveSelectedBadla = true,
  isShowMatchingBadla = true,
  isDisabled = false,
}) => {
  const { values, errors, touched, setFieldValue, resetForm } = useFormik({
    initialValues: {
      badla: null,
      script: null,
    },
    enableReinitialize: true,
    validationSchema: badlaCreateSchema,
  });

  console.log("🚀 ~ SelectBadla ~ values.badla?.value:", values.badla?.value);
  const { badlaModifyOptions, badlaListData } = useBadlaType({
    badlaType: values.badla?.value || "all",
    isRemoveSelectedBadla: isRemoveSelectedBadla,
    isShowMatchingBadla: isShowMatchingBadla,
  });

  const matchScript = useMemo(() => {
    if (!values.script) return null;
    return badlaListData.find((x) => x._id === values.script.value);
  }, [values.script]);

  useEffect(() => {
    handleSelectBadla({
      badlaValues: { ...values, matchScript: matchScript || null },
    });
  }, [matchScript]);

  useEffect(() => {
    if (isClearForm !== null && isClearForm !== undefined) resetForm();
    // setIsClearForm(true);
  }, [isClearForm]);

  useEffect(() => {
    // default selected badlaType
    if (badlaType && badlaOpions) {
      setFieldValue(
        "badla",
        badlaOpions.find(
          (x) => x.value.toLowerCase() === badlaType.toLowerCase(),
        ),
      );
    }
  }, [badlaType, badlaOpions]);

  useEffect(() => {
    // default selected setting name
    // console.log(
    //   "🚀 ~ SelectBadla ~ badlaModifyOptions:",
    //   typeof badlaModifyOptions,
    // );
    if (
      settingName &&
      badlaModifyOptions &&
      typeof badlaModifyOptions === "object" &&
      Object.keys(badlaModifyOptions).length > 0
    ) {
      console.log("🚀 ~ SelectBadla ~ settingName:", settingName);
      setFieldValue(
        "script",
        badlaModifyOptions.find((x) => x.label === settingName),
      );
    }
  }, [settingName, badlaModifyOptions]);

  return (
    // <form className="date-input-main" onSubmit={handleSubmit}>
    //   <div className="row m-0 p-0 align-items-end">
    <>
      <div className={`${customClass || "col-lg-2"} col-6 m-0 p-1`}>
        <div className="date-input-box">
          <Label className="lead_text" htmlFor="">
            Badla list
          </Label>
          <CustomSelect
            className="dropdown-control"
            options={badlaOpions}
            onChange={(selectedOption) => {
              setFieldValue("badla", selectedOption);
            }}
            value={values.badla}
            name="badla"
            id="badla"
            isClearable={true}
            isDisabled={isDisabled}
          />
        </div>
      </div>
      <div className={`${customClass || "col-lg-2"} col-6 m-0 p-1`}>
        <div className="date-input-box">
          <Label for="" className="lead_text">
            script
          </Label>
          <CustomSelect
            className="dropdown-control"
            options={badlaModifyOptions}
            onChange={(selectedOption) => {
              setFieldValue("script", selectedOption);
            }}
            value={values.script}
            name="script"
            id="script"
            isClearable={true}
            isDisabled={isDisabled}
          />
          {errors.script && touched.script && <Error>{errors.script}</Error>}
        </div>
      </div>
    </>
    //   </div>
    // </form>
  );
};

export default memo(SelectBadla);
